import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import { Box, Button, Text } from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'

import Preview from '@components/AttachmentPreview'

import { getFileSizeString } from '@functions/attachment'

import type { UseProviderCampaignMediaPayload } from '../../hooks/useProviderCampaignMedia'

interface AttachmentPreviewProps {
  orderItemPayload: UseProviderCampaignMediaPayload & { campaignTitle: string,
  },
}

const AttachmentPreview = (props: AttachmentPreviewProps) => {
  const { orderItemPayload } = props

  const {
    attachmentType,
    campaignTitle,
    carouselPayload,
    orderItem,
    selectedAttachment,
  } = orderItemPayload

  const fileSize = getFileSizeString(selectedAttachment)

  const dateString = digObject(selectedAttachment.dates, 'created.date_time', '')
  const formattedDate = formatDate(dateString, 'dd/MM/yyyy HH:mm', "ccc dd LLL 'at' h:mma")

  const { callbacks: { createOrEditProviderAttachment } } = useAttachment(selectedAttachment)

  return (
    <Box
      borderBottom="1px solid"
      borderColor="lineColor"
      flexDirection="column"
      padding="large"
    >
      {/*
       // @ts-expect-error TS2741 */}
      <Preview
        attachment={selectedAttachment}
        attachmentType={attachmentType}
        carouselPayload={carouselPayload}
        roundCorners
      />

      <Box paddingTop="large">
        <Box flexDirection="column" justifyContent="center">
          <Text fontSize="xsmall">{selectedAttachment.file_file_name}</Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            Added {formattedDate} | {fileSize || 'N/A'}
          </Text>
        </Box>

        {attachmentType === 'image' && (
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faPencil} />}
            onClick={() => createOrEditProviderAttachment({ campaignTitle, orderItem })}
            size="medium"
            //@ts-expect-error
            width="fit-content"
          >
            Manage Image
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default AttachmentPreview
